import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "vue"
import { usePasswordValidation } from "@/hooks/usePasswordValidation"


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordInput',
  props: {
  value: {
    type: String,
    default: "",
    required: true,
  },
  label: {
    type: String,
    default: "Password",
  },
  required: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {



const form = ref({
  password: "",
})

const showPassword = ref(false)

const togglePasswordVisibility = () => {
  showPassword.value = !showPassword.value
}

const { strengthFeedback, passwordStrengthColor } = usePasswordValidation(
  computed(() => form.value.password)
)

return { __sfc: true,form, showPassword, togglePasswordVisibility, strengthFeedback, passwordStrengthColor }
}

})